<template>
    <div class="body">
        <p  class="font1"  style="padding-top: 8vh;color:#023047;font-weight:bold;">勤勉进取，卓尔不群</p>
        <p  class="font1" style="padding-top: 1.5vh;font-size: 18px;">了解自己，才能成就更好的自己！</p>
        <p  class="font1" style="font-size: 18px;">选择你感兴趣的内容参与成长测评</p>
        <p  class="font1" style="font-size: 18px;">为你的未来定制专属提升方案</p>
        <div style="width: 87%;height:auto;margin: 0 auto;margin-top: 3vh;background-color:rgba(255, 255, 255, 0.5);border-radius:10px;">
            <ul>
                <a href="https://growth-compass-pf.foxconnedu.com/aq" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">逆商</li></a>
                <a href="https://growth-compass-pf.foxconnedu.com/emotional" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">情商</li></a>
                <a href="https://growth-compass-pf.foxconnedu.com/empathy" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">同理心</li></a>
                <a href="https://growth-compass-pf.foxconnedu.com/grit" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">恒毅力</li></a>
                <a href="https://growth-compass-pf.foxconnedu.com/curiosity" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">好奇心</li></a>
                <a href="https://growth-compass-pf.foxconnedu.com/cq" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">文化商数</li></a>
                <a href="https://growth-compass-pf.foxconnedu.com/ocaq" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">组织文化逆商</li></a>
                <a href="https://survey.foxconnedu.com/pdp" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">PDP职业性格</li></a>
                <a href="https://survey.foxconnedu.com" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">LASI领导风格</li></a>
            </ul>
        </div>
    </div>
</template>


<script>

export default {
    props: ["ReportData"],
}
</script>
  
<style scoped>
.body {
    background: 
                url("../../assets/logo1.png") right  top  no-repeat,
                url("../../assets/25January/bg.jpg")  no-repeat;
    background-size: 110px 35px,cover;
    width: 100%;
    height: 100vh;
}
ul{   
    list-style-type: none;
    padding: 0;
    /* color: #000; */
    /* text-align: center; */
}
li {
    list-style-type: none;
    margin-left: 20px;
    align-items: center;
    margin-bottom: 8px; /* 可调整列表项之间的间距 */
}
li::before {
    list-style: none;
    /* content: '\2022';  */
    /* color: #000;  */
    font-size: 1.5em; /* 可调整小圆点的大小 */
    margin-right: 3px; /* 可调整小圆点与文字之间的间距 */
    margin: 0 auto;
}
.font1 {
    width: 92%;
    padding-left: 8%;
    margin: 0;
    text-align: left;
    font-size: 20px;
    color: #023047;
    /* font-weight: bold; */
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 92%;
    padding-left: 8%;
    margin: 0;
    color: #fff;
    font-size: 18px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 20px;
    color: #e06c24;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

</style>